import assem from '@/api/product/assembly'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
	productAssembly: []
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_PRODUCT_ASSEMBLY(state, data){
		state.productAssembly = data
	},
	CLEAR_SETUP(state){
		state.productAssembly = []
	}
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return assem.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return assem.store(data)
  },
  find(context, id) {
    return assem.find(id)
  },
  async getAssembly(context){
    if(!context.state.productAssembly.length > 0){
      let response = await assem.assemblyProduct()
      context.commit('SET_PRODUCT_ASSEMBLY', response.data)
      return response
    }
  }
}